import { useState, useCallback, useEffect } from "react";
import { supabase } from "../components/SupabaseClient";

/**
 * Hook to fetch all user-group memberships and group them by user_id.
 * @returns {{ membershipsByUserId: Map<string, Array>, loading: boolean, error: string|null, refreshMemberships: Function }}
 */
export const useResourceGroupMembership = () => {
  const [membershipsByUserId, setMembershipsByUserId] = useState(new Map());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGroupMemberships = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data, error } = await supabase.rpc("get_all_group_memberships");
      if (error) throw error;

      const map = new Map();
      (data || []).forEach((row) => {
        if (!map.has(row.user_id)) {
          map.set(row.user_id, []);
        }
        map.get(row.user_id).push(row);
      });

      setMembershipsByUserId(map);
    } catch (err) {
      setError(err.message);
      console.error("Failed to fetch group memberships:", err);
      setMembershipsByUserId(new Map());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGroupMemberships();
  }, [fetchGroupMemberships]);

  return {
    membershipsByUserId,
    loading,
    error,
    refreshMemberships: fetchGroupMemberships,
  };
};
